import React, { memo } from 'react';
import { Grid, Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

import { FormattedMessage, useIntl } from 'react-intl';
import { ActionModal } from '../../../components/Modal';
import { Typography } from '../../../components/Typography';

const styles = (theme: Theme) => {
  return createStyles({
    userCard: {},
    right: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
  });
};

export interface IMemberInfoModalProps extends WithStyles<typeof styles> {
  selectedMember: any;
  open: boolean;
  showParent: boolean;
  handleClose: () => void;
}

const MemberInfoModal = ({
  classes,
  selectedMember,
  showParent,
  open,
  handleClose,
}: IMemberInfoModalProps) => {
  const intl = useIntl();
  return (
    <ActionModal
      modalTitle={selectedMember?.profile?.name}
      open={open}
      handleClose={handleClose}
      actinButtonLabel={intl.formatMessage({
        id: 'done',
      })}
      actinButtonOnClick={handleClose}
      isSingleButton
    >
      <Grid container className={classes.userCard}>
        <Grid item className={classes.right}>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="email" /> :&nbsp;
            {selectedMember?.email}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="contact_number" /> :&nbsp;
            {selectedMember?.profile?.contactNumber}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="status" /> :&nbsp;
            {selectedMember?.isVerified
              ? intl.formatMessage({
                  id: 'active',
                })
              : intl.formatMessage({
                  id: 'pending',
                })}
          </Typography>
          {showParent ? (
            <Typography variant="body1" color="secondary">
              <FormattedMessage id="managed_by" /> :&nbsp;
              {selectedMember?.parentId?.profile?.name}
            </Typography>
          ) : (
            ''
          )}
          {/* <Typography variant="body1" color="secondary">
            <FormattedMessage id="participants" /> : &nbsp;
            {meeting?.participantCount}
          </Typography> */}
        </Grid>
      </Grid>
    </ActionModal>
  );
};

export default memo(withStyles(styles)(MemberInfoModal));
